<template>
  <div :class="body_class !== '' ? body_class : 'full-nri-banner'">
		<div class="banner-container">
			<img fetchpriority="high" :src="image_url" alt="">
		</div>
		<div class="banner-content" v-html="body_content"></div>
	</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    body_class: { type: String, default: '' },
    body_content:{ type: String, default:'' },
    image_url: { type: String, default:'' }
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
